import {
    CONTRACT_ALL_FETCHING,
    CONTRACT_ALL_FAILED,
    CONTRACT_ALL_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CONTRACT_ALL_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case CONTRACT_ALL_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case CONTRACT_ALL_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};
